"use strict";

exports.__esModule = true;

var tslib_1 = require("tslib");

var MediaManagerImage_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/MediaManagerImage"));

var utilities_1 = require("@sportnet/ui/lib/Themes/utilities");

var polished_1 = require("polished");

var react_1 = tslib_1.__importDefault(require("react"));

var formatUserName_1 = tslib_1.__importDefault(require("sportnet-utilities/lib/formatUserName"));

var styled_components_1 = require("styled-components");

var styled_components_2 = tslib_1.__importStar(require("../../../theme/styled-components"));

var _utilities_1 = require("../../../utilities");

var _view_1 = tslib_1.__importDefault(require("../.."));

var Icon_1 = tslib_1.__importDefault(require("../../components/Icon"));

var Wrapper = styled_components_2["default"].div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  border-radius: ", ";\n  border: ", " solid #ddd;\n  background-color: ", ";\n  padding: ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  border-radius: ", ";\n  border: ", " solid #ddd;\n  background-color: ", ";\n  padding: ", ";\n"])), polished_1.rem(8), polished_1.rem(1), function (_a) {
  var _b;

  var theme = _a.theme;
  return ((_b = theme === null || theme === void 0 ? void 0 : theme.app) === null || _b === void 0 ? void 0 : _b.bgColor) || '#fff';
}, polished_1.rem(24));
var Header = styled_components_2["default"].div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n  margin: ", ";\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  margin: ", ";\n"])), polished_1.rem(-12));
var LeftHeader = styled_components_2["default"].div(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  padding: ", ";\n  margin-right: auto;\n  align-items: center;\n"], ["\n  display: flex;\n  padding: ", ";\n  margin-right: auto;\n  align-items: center;\n"])), polished_1.rem(12));
var RightHeader = styled_components_2["default"].div(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  padding: ", ";\n  margin: ", ";\n  flex-wrap: wrap;\n"], ["\n  display: flex;\n  padding: ", ";\n  margin: ", ";\n  flex-wrap: wrap;\n"])), polished_1.rem(12), polished_1.rem(-4));
var StyledMediaManagerImage = styled_components_2["default"](MediaManagerImage_1["default"])(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  border-radius: 50%;\n  height: ", ";\n  margin-right: ", ";\n  ", " {\n    height: ", ";\n    margin-right: ", ";\n  }\n  flex-shrink: 0;\n"], ["\n  border-radius: 50%;\n  height: ", ";\n  margin-right: ", ";\n  ", " {\n    height: ", ";\n    margin-right: ", ";\n  }\n  flex-shrink: 0;\n"])), polished_1.rem(48), polished_1.rem(16), utilities_1.mb('s'), polished_1.rem(80), polished_1.rem(24));
var NameWrapper = styled_components_2["default"].h2(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n  font-size: ", ";\n  font-weight: 600;\n  margin: 0;\n  overflow-wrap: break-word;\n"], ["\n  font-size: ", ";\n  font-weight: 600;\n  margin: 0;\n  overflow-wrap: break-word;\n"])), polished_1.em(18));
var Position = styled_components_2["default"].h3(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject(["\n  margin: ", " 0 0 0;\n  font-size: ", ";\n  opacity: 0.56;\n  font-weight: inherit;\n  overflow-wrap: break-word;\n"], ["\n  margin: ", " 0 0 0;\n  font-size: ", ";\n  opacity: 0.56;\n  font-weight: inherit;\n  overflow-wrap: break-word;\n"])), polished_1.rem(4), polished_1.em(14));

var SocialLinkBase = function (_a) {
  var hoverColor = _a.hoverColor,
      rest = tslib_1.__rest(_a, ["hoverColor"]);

  return react_1["default"].createElement("a", tslib_1.__assign({}, rest));
};

var SocialLink = styled_components_2["default"](SocialLinkBase)(templateObject_9 || (templateObject_9 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: ", ";\n  height: ", ";\n  border-radius: 50%;\n  margin: ", ";\n  flex-shrink: 0;\n\n  cursor: pointer;\n  outline: none;\n  border: none;\n\n  opacity: 0.56;\n  background-color: ", ";\n  transition: all 200ms linear;\n  path {\n    fill: ", ";\n    transition: fill 200ms linear;\n  }\n  ", "\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: ", ";\n  height: ", ";\n  border-radius: 50%;\n  margin: ", ";\n  flex-shrink: 0;\n\n  cursor: pointer;\n  outline: none;\n  border: none;\n\n  opacity: 0.56;\n  background-color: ", ";\n  transition: all 200ms linear;\n  path {\n    fill: ", ";\n    transition: fill 200ms linear;\n  }\n  ", "\n"])), polished_1.rem(32), polished_1.rem(32), polished_1.rem(4), function (_a) {
  var _b;

  var theme = _a.theme;
  return ((_b = theme === null || theme === void 0 ? void 0 : theme.app) === null || _b === void 0 ? void 0 : _b.textColor) || '#333';
}, function (_a) {
  var _b;

  var theme = _a.theme;
  return ((_b = theme === null || theme === void 0 ? void 0 : theme.app) === null || _b === void 0 ? void 0 : _b.bgColor) || '#fff';
}, function (_a) {
  var hoverColor = _a.hoverColor;
  return styled_components_2.css(templateObject_8 || (templateObject_8 = tslib_1.__makeTemplateObject(["\n    &:hover,\n    &:focus,\n    &:active {\n      background: ", ";\n      opacity: 1;\n      path {\n        fill: #fff;\n      }\n    }\n  "], ["\n    &:hover,\n    &:focus,\n    &:active {\n      background: ", ";\n      opacity: 1;\n      path {\n        fill: #fff;\n      }\n    }\n  "])), hoverColor);
});
var Perex = styled_components_2["default"].p(templateObject_10 || (templateObject_10 = tslib_1.__makeTemplateObject(["\n  margin: ", " 0 0 0;\n  white-space: pre-wrap;\n  font-size: ", ";\n"], ["\n  margin: ", " 0 0 0;\n  white-space: pre-wrap;\n  font-size: ", ";\n"])), polished_1.rem(24), polished_1.em(14));
var Line = styled_components_2["default"].hr(templateObject_11 || (templateObject_11 = tslib_1.__makeTemplateObject(["\n  margin: ", " 0;\n  width: 100%;\n  display: block;\n  height: ", ";\n  border: 0;\n  border-top: ", " solid #ddd;\n"], ["\n  margin: ", " 0;\n  width: 100%;\n  display: block;\n  height: ", ";\n  border: 0;\n  border-top: ", " solid #ddd;\n"])), polished_1.rem(24), polished_1.rem(1), polished_1.rem(1));
var WidgetsWrapper = styled_components_2["default"].div(templateObject_12 || (templateObject_12 = tslib_1.__makeTemplateObject(["\n  margin: -1em 0;\n  font-size: ", ";\n"], ["\n  margin: -1em 0;\n  font-size: ", ";\n"])), polished_1.em(14));

var Profile = function (_a) {
  var _b = _a.data,
      data = _b === void 0 ? {} : _b,
      renderLink = _a.renderLink,
      theme = _a.theme;
  var userName = react_1["default"].useMemo(function () {
    var surname = [data.prezyvka && "\"" + data.prezyvka + "\"", data.priezvisko].filter(function (x) {
      return x;
    }).join(' ');
    return formatUserName_1["default"]({
      name: data.meno,
      surname: surname
    });
  }, [data.meno, data.prezyvka, data.priezvisko]);
  var social = [data.facebook, data.twitter, data.instagram, data.youtube].filter(function (x) {
    return x;
  });
  var shouldShowWidgets = react_1["default"].useMemo(function () {
    if (data.widgets && data.widgets.length > 0) {
      if (data.widgets.length === 1 && data.widgets.find(function (w) {
        return w.type === 'text' && w.text === '<p><br></p>';
      })) {
        return false;
      }

      return true;
    }

    return false;
  }, [data.widgets]);
  var widgetsTheme = react_1["default"].useMemo(function () {
    return {
      app: tslib_1.__assign(tslib_1.__assign({}, theme.app), {
        padding: 0
      })
    };
  }, [theme.app]);
  return react_1["default"].createElement(Wrapper, null, react_1["default"].createElement(Header, null, react_1["default"].createElement(LeftHeader, null, data.photo && react_1["default"].createElement(StyledMediaManagerImage, {
    picture: data.photo,
    naturalHeight: 80,
    naturalWidth: 80,
    script: "media"
  }), react_1["default"].createElement("div", null, userName && react_1["default"].createElement(NameWrapper, null, userName), data.pozicia && react_1["default"].createElement(Position, null, data.pozicia))), social.length > 0 && react_1["default"].createElement(RightHeader, null, data.facebook && react_1["default"].createElement(SocialLink, {
    href: data.facebook,
    target: "_blank",
    rel: "noopener noreferrer",
    title: _utilities_1.__('Zobraziť Facebook profil:') + " " + userName,
    hoverColor: "#1877F2"
  }, react_1["default"].createElement(Icon_1["default"], {
    name: "facebook-symbol",
    size: 16
  })), data.twitter && react_1["default"].createElement(SocialLink, {
    href: data.twitter,
    target: "_blank",
    rel: "noopener noreferrer",
    title: _utilities_1.__('Zobraziť Twitter profil:') + " " + userName,
    hoverColor: "#1DA1F2"
  }, react_1["default"].createElement(Icon_1["default"], {
    name: "twitter-symbol",
    size: 16
  })), data.instagram && react_1["default"].createElement(SocialLink, {
    href: data.instagram,
    target: "_blank",
    rel: "noopener noreferrer",
    title: _utilities_1.__('Zobraziť Instagram profil:') + " " + userName,
    hoverColor: "#E4405F"
  }, react_1["default"].createElement(Icon_1["default"], {
    name: "instagram-symbol",
    size: 16
  })), data.youtube && react_1["default"].createElement(SocialLink, {
    href: data.youtube,
    target: "_blank",
    rel: "noopener noreferrer",
    title: _utilities_1.__('Zobraziť Youtube kanál:') + " " + userName,
    hoverColor: "#FF0000"
  }, react_1["default"].createElement(Icon_1["default"], {
    name: "youtube-symbol",
    size: 16
  })))), data.poznamka && react_1["default"].createElement(Perex, null, data.poznamka), shouldShowWidgets && react_1["default"].createElement(react_1["default"].Fragment, null, react_1["default"].createElement(Line, null), react_1["default"].createElement(WidgetsWrapper, null, react_1["default"].createElement(styled_components_1.ThemeProvider, {
    theme: widgetsTheme
  }, react_1["default"].createElement(_view_1["default"], {
    items: data.widgets || [],
    renderLink: renderLink
  })))));
};

exports["default"] = styled_components_2.withTheme(Profile);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;